<template>
    <v-card class="panelBlock network-administrator" v-if="currentCommunityView === userRoles.ADMIN">
        <v-flex tag="h2">{{title}}</v-flex>
        <v-flex v-if="isNetwork || isGroup" class="network-administrator__row" data-qe-id="network_admin_request"
                @click="requestedMembers()">
            <v-flex class="network-administrator__details">
                <i class="fas fa-user-alt"></i> {{Administration.REQUESTS}}
            </v-flex>
        </v-flex>
        <v-flex v-if="isHospitalityNetwork && viewPendingAssetRequest" data-qe-id="network_admin_pending_request"
                @click="showPendingAssets()" class="network-administrator__row">
            <v-flex class="network-administrator__details">
                <i class="fas fa-building"></i> {{Administration.PENDING_ASSET_REQUEST}}
            </v-flex>
        </v-flex>
        <v-flex v-if="isGroup" class="network-administrator__row" data-qe-id="network_admin_invite_someone"
                @click="manageParticipants()">
            <v-flex class="network-administrator__details">
                <i class="fas fa-users"></i> {{Administration.MANAGE_PARTICIPANTS}}
            </v-flex>
        </v-flex>
        <v-flex v-if="isGroup" class="network-administrator__row" data-qe-id="configure_group"
                @click="configureGroup()">
            <v-flex class="network-administrator__details">
                <i class="fas fa-cogs"></i> {{Administration.CONFIGURE_GROUP}}
            </v-flex>
        </v-flex>
        <v-flex v-if="isNetwork || isGroup" class="network-administrator__row"
                data-qe-id="invite_someone"
                @click="inviteSomeone()">
            <v-flex class="network-administrator__details">
                <i class="fas fa-user-plus"></i> {{Administration.INVITE_SOMEONE}}
            </v-flex>
        </v-flex>
    </v-card>
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex';
    import { storeMutation } from "../../store/storeMutations.constant";
    import { userRoles } from '../appCommon.constants';
    import { Administration, NetworkConstants } from './NetworkConstants';
    import { storeGetters } from '@/store/storeGetters.constant';

    export default {
        name: 'AdministrationOptions',
        data: () => ({
            userRoles,
            Administration,
        }),
        created() {
            this.toggleRequestedMembers(false);
        },
        props: {
            isGroup: {
                type: Boolean,
                default: false,
            },
            isNetwork: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: '',
            },
        },
        methods: {
            ...mapMutations({
                toggleRequestedMembers: `network/${storeMutation.toggleRequestedMembers}`,
                toggleRequestedGroups: `network/${storeMutation.toggleRequestedGroups}`,
                toggleInviteSomeone: `network/${storeMutation.toggleInviteSomeone}`,
                toggleManageParticipants: `network/${storeMutation.toggleManageParticipants}`,
                toggleConfigureGroup: `network/${storeMutation.toggleConfigureGroup}`,
                togglePendingAssetRequests: `network/${storeMutation.togglePendingAssetRequests}`,
            }),
            requestedMembers() {
                this.toggleRequestedMembers(true);
            },
            inviteSomeone() {
                this.toggleInviteSomeone(true);
            },
            manageParticipants() {
                this.toggleManageParticipants(true);
            },
            configureGroup() {
                this.toggleRequestedGroups(false);
                setTimeout(() => {
                    this.toggleConfigureGroup(true);
                }, 0);
            },
            showPendingAssets() {
                this.togglePendingAssetRequests();
            },
        },
        computed: {
            ...mapGetters({
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                viewPendingAssetRequest: `network/${storeGetters.viewPendingAssetRequest}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
            }),
            isHospitalityNetwork() {
                return this.communityInfo && this.communityInfo.communityId && this.communityInfo.communityId.toLowerCase() === NetworkConstants.HOSPITALITY_BUSINESS_NETWORK_COMMUNITY_ID;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .network-administrator {
        &__row {
            position: relative;
            color: $ypo_blue;
            margin: 0;
            align-items: center;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                background: rgba($ypo-tile-border, 0.3);
                font-weight: 600;
            }
        }

        &__details {
            border-bottom: 1px solid rgba($ypo-tile-border, 0.3);
            margin: 0 15px;
            padding: 15px 0;

            i {
                font-size: 20px;
                margin-right: 5px;
            }
        }
    }
</style>
